import React from 'react';

export const ProfileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={140}
    height={120}
    viewBox="0 0 140 120"
  >
    <title>Profile icon</title>
    <defs>
      <path
        id="a"
        d="M0 0.38516965L127.544 0.38516965 127.544 104.031405 0 104.031405z"
      />
      <path
        id="c"
        d="M0.411359385 0.528L5.26323441 0.528 5.26323441 9.73807317 0.411359385 9.73807317z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#EAF0FA"
        d="M95.5774415,120 C103.525557,120 110.029288,113.408 110.029288,105.351 L110.029288,14.649 C110.029288,6.592 103.525557,0 95.5774415,0 L14.4518469,0 C6.50273094,0 0,6.592 0,14.649 L0,105.351 C0,113.408 6.50273094,120 14.4518469,120 L95.5774415,120 Z"
      />
      <line
        x1="21.397"
        x2="70.595"
        y1="84.302"
        y2="84.302"
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <line
        x1="21.397"
        x2="71.223"
        y1="91.747"
        y2="91.747"
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        fill="#FFF"
        d="M58.3214244,51.5234 C58.3214244,55.9234 54.7194656,59.5234 50.3192943,59.5234 L28.9556076,59.5234 C24.5534358,59.5234 20.9534775,55.9234 20.9534775,51.5234 L20.9534775,29.6284 C20.9534775,25.2284 24.5534358,21.6284 28.9556076,21.6284 L50.3192943,21.6284 C54.7194656,21.6284 58.3214244,25.2284 58.3214244,29.6284 L58.3214244,51.5234 Z"
      />
      <path
        stroke="#031D44"
        strokeLinecap="round"
        strokeWidth="2"
        d="M46.4051525 37.1264C46.4051525 40.9174 43.086269 45.1384 39.6363507 45.1384 36.2174406 45.1384 32.8685492 40.9174 32.8685492 37.1264 32.8685492 33.3354 35.8983557 30.2624 39.6363507 30.2624 43.375346 30.2624 46.4051525 33.3354 46.4051525 37.1264zM52.6890251 58.1635C52.3809431 54.2335 50.0843318 50.9765 47.0055123 50.2635 44.6388823 49.7145 41.9221591 49.2355 39.6545555 49.2355 37.2659197 49.2355 34.592208 49.6925 32.2885948 50.2265 28.9827148 50.9915 26.5850766 54.7065 26.5850766 59.0235L26.5850766 64.3595"
      />
      <line
        x1="21.397"
        x2="50.462"
        y1="99.077"
        y2="99.077"
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="2"
      />
      <path
        stroke="#031D44"
        strokeLinecap="round"
        strokeWidth="2"
        d="M71.9031397,71.924 L56.5140433,56.708 C62.5786576,50.7 66.3336572,42.367 66.3336572,33.158 C66.3336572,14.845 51.4847046,0 33.1668286,0 C14.8499529,0 0,14.845 0,33.158 C0,51.47 14.8499529,66.316 33.1668286,66.316 C39.085404,66.316 44.6418831,64.766 49.4521635,62.05"
        transform="translate(67.097 24.038)"
      />
    </g>
  </svg>
);
